export function articleNo(str) {
  const match = str.match(/^S?\d+/);
  if (match && match[0]) {
    return match[0];
  }
}
